module.exports = __webpack_public_path__ + "img/FR24333.55bdd457.png";